/**
 * PKN Early Access Opt-in Confirm
 * ---------------------------------------------------------------------------
 * Detects the URL a visitor lands on after clicking the confirmation link in a
 * double opt-in email and shows the success dialog instead of leaving them
 * staring at the password form with no feedback.
 *
 * The matcher is merchant configured because the parameter depends on the
 * email tool: the section settings take either a query parameter name (with an
 * optional expected value) or a substring to look for anywhere in the URL.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pknOptinReady === 'true') return;
    root.dataset.pknOptinReady = 'true';

    var dialog = document.getElementById(root.dataset.dialogId);
    if (!dialog) return;

    function open() {
      if (dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        // Browsers without <dialog> support: the CSS centres [open] the same way.
        dialog.setAttribute('open', '');
      }
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-pkn-optin-close]')) {
        event.preventDefault();
        close();
      }
    });

    // Clicking the backdrop closes it: the dialog box only covers its own rect,
    // so a click on the element that lands outside that rect is the backdrop.
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom
      ) {
        close();
      }
    });

    // In the theme editor, show the dialog while the section is selected so it
    // can actually be designed.
    if (root.dataset.designMode === 'true') {
      var mine = function (event) {
        return event && event.detail && event.detail.sectionId === root.dataset.sectionId;
      };
      document.addEventListener('shopify:section:select', function (e) {
        if (mine(e)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (mine(e)) close();
      });
      document.addEventListener('shopify:section:unload', function (e) {
        if (mine(e)) close();
      });
      open();
      return;
    }

    var param = (root.dataset.matchParam || '').trim();
    if (!param) return;

    var url;
    try {
      url = new URL(window.location.href);
    } catch (e) {
      return;
    }

    // Hard guard: Shopify appends ?customer_posted=true when the signup form
    // itself redirects back. That is the "check your inbox" state and belongs
    // to the form's own confirmation — this dialog is only for the link clicked
    // inside the confirmation email.
    if (url.searchParams.get('customer_posted') === 'true') return;

    var value = (root.dataset.matchValue || '').trim();
    var matched = false;

    if (root.dataset.matchStrategy === 'url_contains') {
      var haystack = (url.search + ' ' + url.hash + ' ' + url.pathname).toLowerCase();
      if (haystack.indexOf(param.toLowerCase()) !== -1) {
        matched = !value || haystack.indexOf(value.toLowerCase()) !== -1;
      }
    } else {
      var found = url.searchParams.get(param);
      if (found !== null) matched = !value || found === value;
    }

    if (!matched) return;

    open();

    // Leave a clean URL behind so a reload or a shared link does not re-trigger
    // the success screen.
    if (root.dataset.clearUrl === 'true' && root.dataset.matchStrategy !== 'url_contains') {
      try {
        url.searchParams.delete(param);
        var search = url.searchParams.toString();
        window.history.replaceState({}, '', url.pathname + (search ? '?' + search : '') + url.hash);
      } catch (e) {
        /* no-op */
      }
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pkn-optin]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('[data-pkn-optin]')
      : null;
    if (root) init(root);
  });
})();
